export default __webpack_public_path__ + "static/media/yellow.34370af1.png";